import store from '@/store'

const preload = src => new Promise((resolve, reject) => {
	const img = new Image()
	img.onload = resolve
	img.onerror = reject
	img.src = src
})
const preloadAll = srcs => Promise.all(srcs.map(preload))

const Medias = {
	files: [],
	async init() {
		if (Medias.files.length === 0) {
			let start = Date.now()
			let images = []
			try {
				// eslint-disable-next-line no-undef
				const files = require.context('@/assets/img/', true, /^.*\.jpg|png|svg$/).keys()

				for (let id in files) {
					const name = files[id].substr(2)

					// eslint-disable-next-line no-undef
					const url = require('@/assets/img/' + name)
					images.push({ id: parseInt(id), name, url })
				}

				Medias.files = images
				await preloadAll(images.map((i) => i.url))

				store.commit('SET_LOADED', { images: true })
				console.info(Medias.files.length + ' images loaded in ' + (Date.now() - start) + 'ms')
			} catch (e) {
				console.error(e)
				alert(e.message)
			}
		}
	},
	get(data = {}) {
		let m = Medias.files.find((f) => { return f.name == data.name })
		if (m) return m.url
		return ''
	}
}

export default Medias 